module.exports = __webpack_public_path__ + "img/404.717eb465.png";